import React, { useState } from "react";
import { FilterDropdown } from "./FilterDropdown";
import { TIERS } from "./constants";

function formatFollowerValue(value: number): string {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
  return value.toString();
}

interface Props {
  selectedTier: string;
  onTierSelect: (value: string) => void;
  onClearTier: () => void;
}

export function TierFilter({ selectedTier, onTierSelect, onClearTier }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <FilterDropdown
      label="Followers"
      count={selectedTier ? 1 : 0}
      open={open}
      setOpen={setOpen}
      width="w-[260px]"
    >
      {TIERS.map((tier) => (
        <button
          key={tier.value}
          type="button"
          onClick={() => onTierSelect(tier.value)}
          className="w-full text-left px-4 py-3 rounded-[14px] font-raleway text-[16px]"
        >
          <div className="flex items-start gap-3">
            <div className="mt-1 w-4 h-4 rounded-full border-2 border-[#9CA3AF] flex items-center justify-center">
              {selectedTier === tier.value && <div className="w-2 h-2 rounded-full bg-[#9333EA]" />}
            </div>
            <div className="flex items-baseline gap-2">
              <span className="text-[16px] font-medium leading-none">{tier.label}</span>
              <span className="text-[16px] font-raleway text-[#000000]">
                ({formatFollowerValue(tier.min)} – {formatFollowerValue(tier.max)})
              </span>
            </div>
          </div>
        </button>
      ))}

      <button
        type="button"
        onClick={onClearTier}
        className="w-full text-left px-4 py-3 rounded-[14px] text-[16px] font-raleway transition"
      >
        <div className="flex items-center gap-3">
          <div className="w-4 h-4 rounded-full border-2 border-[#9CA3AF] flex items-center justify-center">
            {!selectedTier && <div className="w-2 h-2 rounded-full bg-[#9333EA]" />}
          </div>
          <span className="text-[16px] font-medium text-[#111827]">All</span>
        </div>
      </button>
    </FilterDropdown>
  );
}
